import { FieldViewModel, ICropping, ICroppingHistory } from "../../fields"
import { createIndex, groupBy, selectMany } from "../../utils/array"
import { CroppingHistory } from "../autohistory"
import { getStdFieldHistory } from "../history"
import { Years } from "./types"

export interface CroppingHistoryProvider {
    getPrevious(crop: ICropping): ICropping[]
    getNext(crop: ICropping): ICropping[]
}

export function getHistoryProvider(years: Years, fields: FieldViewModel[]) {

    if (!(years && fields)) {
        return getProvider(c => c)()
    }

    const crops = selectMany(fields.map(f => f.croppings))
        .map(c => c.cropping)
        .filter(c => (c.YearId >= years.first) && (c.YearId <= years.last))

    const groups = groupBy(crops, c => c.Field, f => f.FieldId)

    const history = selectMany(groups.map(g => getStdFieldHistory(g.values, { fieldArea: g.key.CroppingArea, fieldName: g.key.Name })))

    const index = createIndex(history, h => h.cropping.CroppingId)

    const get = (c: ICropping, rel: (h: CroppingHistory<ICropping>) => ICropping[]) => {
        const t = index[c.CroppingId]
        return t ? (rel(t) || []) : []
    }

    return {
        getNext: c => get(c, h => h.next),
        getPrevious: c => get(c, h => h.prev),
    }

}

function getProvider(h: (c: ICropping) => ICroppingHistory) {

    const get = (c: ICropping, rel: (h: ICroppingHistory) => ICropping[]) => {
        const t = h(c)
        return t ? (rel(t) || []) : []
    }

    return () => ({
        getNext: c => get(c, h => h.NextCroppings),
        getPrevious: c => get(c, h => h.PreviousCroppings),
    }) as CroppingHistoryProvider

}
